import React ,{useState,useEffect} from "react";
import {Descriptions, Card, Button, Modal, message,Tag, Divider, Form, Input, Tooltip, Row, Col} from 'antd';
import {EditOutlined,InfoCircleOutlined,LockTwoTone,UserOutlined} from '@ant-design/icons'
import {getHostAddress,isNull} from "../../Tool/UtileFun";
import cookie from "react-cookies";
import { Typography, Space } from 'antd';
// 引入编辑器组件
import BraftEditor from 'braft-editor'
// 引入编辑器样式
import 'braft-editor/dist/index.css'
import 'braft-editor/dist/output.css'


export function AdminInfoCar(){

    useEffect(
        ()=>{
            findById()
            //editLoadValue()
        },[]
    )



    let newPassword = "";
    let againNewPassword = "";
    let oldPassword = "";
    const { Text, Link } = Typography;
    const userId = "userId"
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [userInfo, setUserInfo] = useState([]);
    const [passwordInfo,setPasswordInfo] = useState("")
    const [editModal,setEditModal] = useState(false)
    const [editorState,setEditorState] = useState(null)
    const [richTextContent,setRichTextContent] = useState()

    const editModalShow=()=>{
        setEditModal(true)
    }
    const editModalOk=()=>{
        if (telNumber == null || telNumber == undefined){
            setEditModal(false)
            return
        }
        editTelNumber(telNumber)
        setEditModal(false)
    }
    const editModalCancel=()=>{
        setEditModal(false)
    }

    const showModal = () => {
        setIsModalVisible(true);
    };

    //确定  修改密码
    const handleOk = () => {
        //更新密码
        //updatePassword()
        updateUserPassword()
        setIsModalVisible(false);
    };

    const updatePassword = () =>{
        if (isNull(oldPassword))  {message.warn("旧密码为空"); return }
        if (isNull(newPassword))  {message.warn("新密码为空"); return }
        if (isNull(againNewPassword))  {message.warn("二次新密码为空"); return }
        //updateUserPassword(newPassword)
    }

    const handleCancel = () => {
        setIsModalVisible(false);
    };



    let telNumber
    const telNumberChange = e =>{
        telNumber = e.target.value
    }

    const [newPwd,setNewPwd] = useState()
    const newPasswordChange = e =>{
        newPassword = e.target.value
        setNewPwd(e.target.value)

        if (newPassword === "" || newPassword === undefined || newPassword === null){
            setButtonState(false)
            setPasswordInfo("密码不能为空")
            return
        }else {
            setPasswordInfo()
        }

        if (againPwd === undefined || againPwd ===""){

        }else {
            if (againPwd === newPassword){
                setButtonState(true)
                setPasswordInfo()
            }else {
                setButtonState(false)
                setPasswordInfo("密码不一致")
            }
        }
    }

    const [againPwd,setAgainPwd] = useState()
    const [buttonState,setButtonState] = useState(false)
    const againNewPasswordChange = e =>{
        againNewPassword = e.target.value
        setAgainPwd(e.target.value)

        if (againNewPassword === "" || againNewPassword === undefined || againNewPassword === null){
            setPasswordInfo("密码不能为空")
            return
        }else {
            setPasswordInfo()
        }

        if (newPwd === againNewPassword){
            setButtonState(true)
            setPasswordInfo()
        }else {
            setButtonState(false)
            setPasswordInfo("密码不一致")
        }
    }

    const [oldPwd,setOLdPwd] = useState()
    const oldPasswordChange = e =>{
        oldPassword = e.target.value
        setOLdPwd(e.target.value)

        if (oldPassword === "" || oldPassword === undefined || oldPassword === null){
            setButtonState(false)
            setPasswordInfo("密码不能为空")
            return
        }else {
            setPasswordInfo()
        }
    }

    const findById=()=>{
        fetch(
            "http://"+getHostAddress()+"/user/findById",
            {
                method:'post',
                headers:{
                    'Content-Type':'application/json',
                },
                body:JSON.stringify({id:cookie.load(userId)}),
            }
        )
            .then( res =>{ if( res.ok) return res.json()
            })
            .then(data=>{
                console.log(data)
                setUserInfo(data)
            })
            .catch(error => message.error("error"+error));
    }

    const editTelNumber=(telNumber)=>{
        fetch(
            "http://"+getHostAddress()+"/user/editTelNumber",
            {
                method:'post',
                headers:{
                    'Content-Type':'application/json',
                },
                body:JSON.stringify({id:cookie.load(userId),telNumber:telNumber}),
            }
        )
            .then( res =>{ if( res.ok) return res.json()
            })
            .then(data=>{
                //刷新
                findById()
            })
            .catch(error => message.error("error"+error));
    }

    const updateUserPassword=()=>{
        fetch(
            "http://"+getHostAddress()+"/user/updatePassword",
            {
                method:'post',
                headers:{
                    'Content-Type':'application/json',
                },
                body:JSON.stringify({userId:cookie.load(userId),newPwd:newPwd,oldPwd:oldPwd}),
            }
        )
            .then( res =>{ if( res.ok) return res.json()
            })
            .then(data=>{
                //setUserInfo(data)
                if (data.state === "success"){
                    message.success(data.message)
                }else {
                    message.error(data.message)
                }
            })
            .catch(error => message.error("error"+error));
    }




    const editLoadValue=(value)=>{
        fetch(
            "http://"+getHostAddress()+"/experiment/getEditValue",
            {
                method:'post',
                headers:{
                    'Content-Type':'application/json',
                },
                body:JSON.stringify({}),
            }
        )
            .then( res =>{ if( res.ok) return res.json()
            })
            .then(data=>{
                console.log(data)
                setRichTextContent(data.description)
                setEditorState(BraftEditor.createEditorState(data.description))
            })
            .catch(error => message.error("error"+error));
    }

    const editsave=(value)=>{
        fetch(
            "http://"+getHostAddress()+"/experiment/saveText",
            {
                method:'post',
                headers:{
                    'Content-Type':'application/json',
                },
                body:JSON.stringify({description:value}),
            }
        )
            .then( res =>{ if( res.ok) return res.json()
            })
            .then(data=>{
                console.log(data)
                //setEditorState(BraftEditor.createEditorState(data.value))
            })
            .catch(error => message.error("error"+error));
    }




    const form = (
        <Form>
            <Form.Item label=""
                       name="oldPassword"
            >
                <Input
                    prefix={<LockTwoTone className="site-form-item-icon" />}
                    placeholder={"旧密码"}
                    type={"password"}
                    onChange={oldPasswordChange}
                />
            </Form.Item>
            <Form.Item label=""
                       name="newPassword"
            >
                <Input
                    prefix={<LockTwoTone className="site-form-item-icon" />}
                    placeholder={"新密码"}
                    type={"password"}
                    onChange={newPasswordChange}
                />
            </Form.Item>
            <Form.Item   label=""
                         name="againNewPassword"
            >
                <Input
                    placeholder="确认密码"
                    prefix={<LockTwoTone className="site-form-item-icon" />}
                    suffix={
                        <Tooltip title="再输一遍新密码，以防错误">
                            <InfoCircleOutlined style={{ color: 'rgba(0,0,0,.45)' }} />
                        </Tooltip>
                    }
                    type={"password"}
                    onChange={againNewPasswordChange}
                />
                <Text type="danger">{passwordInfo}</Text>
            </Form.Item>
        </Form>
    )

    let editValue
    const handleEditorChange = (editorState) => {
        console.log(editorState.toHTML())
        editValue = editorState.toHTML()
    }
    const submitContent = () => {
        // 在编辑器获得焦点时按下ctrl+s会执行此方法
        // 编辑器内容提交到服务端之前，可直接调用editorState.toHTML()来获取HTML格式的内容
        console.log("save")
        console.log(editValue)
        editsave(editValue)
    }

    const carButton=(
        <>
            <Row gutter={[24,24]}>
                <Col><Button type={"primary"} icon={<EditOutlined />} onClick={editModalShow}>编辑信息</Button></Col>
                <Col><Button style={{margin:"0 0 0 900px"}} type={"primary"} danger onClick={showModal} icon={<EditOutlined />}>修改密码</Button></Col>
            </Row>
        </>
    )



    return(
        <>
            <Card title={carButton}>
                <Descriptions title="用户信息">
                    <Descriptions.Item label="账户名">{userInfo.name}</Descriptions.Item>
                    <Descriptions.Item label="角色">{userInfo.role}</Descriptions.Item>
                    <Descriptions.Item label="电话号码">{userInfo.telNumber}</Descriptions.Item>
                </Descriptions>
            </Card>
            <Modal
                title="修改密码"
                visible={isModalVisible}
                onOk={handleOk}
                onCancel={handleCancel}
                okText={"确定"}
                cancelText={"取消"}
                disabled={true}
                okButtonProps={{
                    disabled:!buttonState
                }}
            >
                {form}
            </Modal>
            <Modal
                title="编辑信息"
                visible={editModal}
                onOk={editModalOk}
                onCancel={editModalCancel}
                okText={"确定"}
                cancelText={"取消"}
            >
                <Input
                    placeholder={"输入新的电话号码"}
                    onChange={telNumberChange}
                />
            </Modal>
            {/*<div className="braft-output-content" dangerouslySetInnerHTML={{__html: richTextContent}} />*/}
        </>
    )
}
